import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  className?: string;
  opacity?: string;
}
const ButcherPaper = ({ className }: Props) => {
  return (
    <div
      className={classNames(
        'absolute inset-0 pointer-events-none bg-butcherPaperBackground opacity-20',
        className,
      )}
    />
  );
};

export default ButcherPaper;
